module.exports = __webpack_public_path__ + "1b2dbc7134a3b4c255ecad17fb6b64e3.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_finance.svg
// module id = ./images/space_finance.svg
// module chunks = 5